import type { IconType } from 'react-icons';
import {
    LuBadgeCheck,
    LuBookUser,
    LuBug,
    LuBuilding2,
    LuCalendarFold,
    LuCloud,
    LuCodesandbox,
    LuFileChartColumn,
    LuFolderDown,
    LuLayoutGrid,
    LuLink2,
    LuListChecks,
    LuMessageSquare,
    LuPanelsTopLeft,
    LuPlay,
    LuRefreshCw,
    LuTag,
    LuUsers,
    LuWallet,
    LuWarehouse
} from 'react-icons/lu';

import Nivaliz from './svg/nivaliz';

export const NAVIGATION_ICONS = {
    USER_MANAGER: LuUsers,
    ORGANIZATION: LuBuilding2,
    FINANCIALS: LuWallet,
    INVENTORY: LuWarehouse,
    CONTENT_AND_MEDIA: LuPlay,
    APPLICATIONS: LuLayoutGrid,
    QUESTION_AND_ANSWER: LuMessageSquare,
    EQUIPMENT: LuCodesandbox,
    QUOTAS_AND_CONSTRAINTS: LuLink2,
    CERTIFICATES: LuBadgeCheck,
    IOT: LuCloud,
    PRODUCT: LuTag,
    CONTACT: LuBookUser,
    IMPORT: LuFolderDown,
    RULE: LuListChecks,
    SYNC: LuRefreshCw,
    EVENT: LuCalendarFold,
    NOTIFICATION_TEMPLATE: LuPanelsTopLeft,
    REPORT: LuFileChartColumn,
    DEBUG: LuBug,
    NIVALIZ: Nivaliz as IconType
};
